import styled from 'styled-components';

export const AuthPhoneNumberInputCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const AuthFormContainerHeading = styled.div`
  font-family: Inter;
  font-size: 32px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: -0.02em;
  text-align: left;
  @media (max-width: 768px) {
    font-size: 18px;
    font-weight: 600;
    line-height: 21.78px;
  }
`;
export const GetOTPText = styled.div``;
export const ErrorText = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  max-width: 420px;
  line-height: 20px;
  color: #ff0000;
  margin-top: 8px;
`;

export const PhoneNumberCardCustomHeading = styled.div``;

export const PhoneNumberCardCustomDescription = styled.div``;
